(() => {
  'use strict';

  const CONFIG = {
    buttonSelector: '#customily-cart-btn',
    cartBubbleSelector: '[ref="cartBubbleCount"]',
    timeout: 15000,
    modalId: 'wasschenk-cart-feedback-modal'
  };

  const STATE = {
    pending: false,
    previousCount: null,
    timer: null,
    modalOpen: false
  };

  /* ----------------------------------------
     Helpers
  ---------------------------------------- */

  function getCartCount() {
    const bubble = document.querySelector(CONFIG.cartBubbleSelector);

    if (!bubble) {
      return null;
    }

    const text = bubble.textContent || '';
    const match = text.replace(/\s/g, '').match(/\d+/);

    return match ? parseInt(match[0], 10) : null;
  }

  function clearPending() {
    STATE.pending = false;
    STATE.previousCount = null;

    if (STATE.timer) {
      clearTimeout(STATE.timer);
      STATE.timer = null;
    }
  }

  /* ----------------------------------------
     Modal
  ---------------------------------------- */

  function createModal() {
    if (document.getElementById(CONFIG.modalId)) {
      return document.getElementById(CONFIG.modalId);
    }

    const modal = document.createElement('div');

    modal.id = CONFIG.modalId;
    modal.className = 'wasschenk-cart-feedback';
    modal.setAttribute('aria-hidden', 'true');

    modal.innerHTML = `
      <div class="wasschenk-cart-feedback__overlay"></div>

      <div
        class="wasschenk-cart-feedback__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="wasschenk-cart-feedback-title"
      >
        <button
          type="button"
          class="wasschenk-cart-feedback__close"
          aria-label="Schließen"
        >
          <svg
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path d="M6 6L18 18M18 6L6 18"></path>
          </svg>
        </button>

        <div class="wasschenk-cart-feedback__icon" aria-hidden="true">
          <svg
            viewBox="0 0 48 48"
          >
            <circle cx="24" cy="24" r="20"></circle>
            <path d="M15.5 24.5L21.5 30.5L33 18.5"></path>
          </svg>
        </div>

        <div class="wasschenk-cart-feedback__content">
          <h2
            id="wasschenk-cart-feedback-title"
            class="wasschenk-cart-feedback__title"
          >
            Erfolgreich hinzugefügt
          </h2>

          <p class="wasschenk-cart-feedback__message">
            Dein personalisiertes Geschenk ist bereit.
          </p>
        </div>

        <div class="wasschenk-cart-feedback__actions">
          <button
            type="button"
            class="wasschenk-cart-feedback__continue"
          >
            Weiter shoppen
          </button>

          <a
            href="/cart"
            class="wasschenk-cart-feedback__checkout"
          >
            Zum Warenkorb
          </a>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    const overlay = modal.querySelector(
      '.wasschenk-cart-feedback__overlay'
    );

    const closeButton = modal.querySelector(
      '.wasschenk-cart-feedback__close'
    );

    const continueButton = modal.querySelector(
      '.wasschenk-cart-feedback__continue'
    );

    overlay.addEventListener('click', closeModal);
    closeButton.addEventListener('click', closeModal);
    continueButton.addEventListener('click', closeModal);

    return modal;
  }

  function openModal() {
    if (STATE.modalOpen) {
      return;
    }

    const modal = createModal();

    STATE.modalOpen = true;

    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add(
      'wasschenk-cart-feedback-open'
    );

    requestAnimationFrame(() => {
      modal.classList.add('is-visible');
    });

    const closeButton = modal.querySelector(
      '.wasschenk-cart-feedback__close'
    );

    if (closeButton) {
      setTimeout(() => {
        closeButton.focus();
      }, 50);
    }
  }

  function closeModal() {
    const modal = document.getElementById(CONFIG.modalId);

    if (!modal) {
      return;
    }

    STATE.modalOpen = false;

    modal.classList.remove('is-visible');
    modal.setAttribute('aria-hidden', 'true');

    document.documentElement.classList.remove(
      'wasschenk-cart-feedback-open'
    );
  }

  /* ----------------------------------------
     Cart Bubble Observer
  ---------------------------------------- */

  function checkCartChange() {
    if (!STATE.pending) {
      return;
    }

    const currentCount = getCartCount();

    if (
      currentCount !== null &&
      STATE.previousCount !== null &&
      currentCount > STATE.previousCount
    ) {
      clearPending();
      openModal();
    }
  }

  function observeCartBubble() {
    const observer = new MutationObserver(() => {
      checkCartChange();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  /* ----------------------------------------
     Customily Add to Basket
  ---------------------------------------- */

  function handleCustomilyClick(event) {
    const button = event.target.closest(
      CONFIG.buttonSelector
    );

    if (!button) {
      return;
    }

    /*
      Important:
      Capture phase runs before Customily's own click handler.
      Therefore we can record the cart count BEFORE Customily
      starts its add-to-cart process.
    */

    STATE.previousCount = getCartCount();
    STATE.pending = true;

    if (STATE.timer) {
      clearTimeout(STATE.timer);
    }

    STATE.timer = setTimeout(() => {
      clearPending();
    }, CONFIG.timeout);
  }

  /* ----------------------------------------
     Keyboard
  ---------------------------------------- */

  document.addEventListener(
    'keydown',
    (event) => {
      if (
        event.key === 'Escape' &&
        STATE.modalOpen
      ) {
        closeModal();
      }
    }
  );

  /* ----------------------------------------
     Init
  ---------------------------------------- */

  function init() {
    /*
      Use capture phase because Customily controls
      the Add to Basket click itself.
    */
    document.addEventListener(
      'click',
      handleCustomilyClick,
      true
    );

    observeCartBubble();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

})();